import script from "./tutorOnboardingSecondPage.vue?vue&type=script&setup=true&lang=js"
export * from "./tutorOnboardingSecondPage.vue?vue&type=script&setup=true&lang=js"

import "./tutorOnboardingSecondPage.vue?vue&type=style&index=0&id=0ab1156d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ab1156d"]])

export default __exports__